/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-20 13:52:31
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Button, Popover, ActionList, Icon } from '@shopify/polaris';
import { LanguageMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  locales: Array<Object>,
  localeName: String,
  onChange: Function
};

type ComposedProps = Props & WithI18nProps;

type State = {
  active: boolean
};

class Languages extends Component<ComposedProps, State> {
  state = {
    active: false
  };

  togglePopover = () => {
    this.setState(({ active }) => {
      return { active: !active };
    });
  };

  render() {
    const { i18n, locales, localeName } = this.props;

    // Get display name
    const isPrimary = _.find(locales, { name: localeName, primary: true });
    const name =
      localeName && isPrimary
        ? `${localeName} ${i18n.translate('AdminHTML.Translation.Translation.suffixMain')}`
        : localeName
        ? localeName
        : '';

    const activator = (
      <Button onClick={this.togglePopover} disclosure>
        <Icon source={LanguageMinor} color="colorInk" />
        <span>{name}</span>
      </Button>
    );

    // Init list of locale
    const actionListItems = locales.map(item => {
      const { locale, name, primary } = item;
      return {
        content: primary ? <div className="languageItem">{name} main</div> : name,
        onAction: () => this.onChange(locale)
      };
    });

    return (
      <div className="languages">
        {locales.length > 0 ? (
          <Popover active={this.state.active} activator={activator} onClose={this.togglePopover}>
            <Popover.Pane>
              <ActionList items={actionListItems} />
            </Popover.Pane>
          </Popover>
        ) : (
          <Button onClick={() => {}} disclosure loading></Button>
        )}
      </div>
    );
  }

  onChange = locale => {
    // Hide popup
    this.togglePopover();

    // Update form
    this.props.onChange(locale);
  };
}

export default withI18n()(Languages);
